import { bootstrapDevAuth } from '@frontend-platform/dev-auth';
import '@frontend-platform/ui-lib/dist/index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './app.css';

// Standalone-dev-only entry point. aistudio only ever mounts Observation
// Tools via Module Federation (federation-app.tsx) — there is no other
// integration surface, so this file has no host handshake to perform.
const envBotId = import.meta.env.VITE_DEV_BOT_ID;
if (envBotId && typeof window !== 'undefined') {
  try {
    localStorage.setItem('currentBotId', envBotId);
    const existing = localStorage.getItem('currentBot');
    const bot = existing ? JSON.parse(existing) : { orgId: 1, name: 'Netomi Dev AI Agent' };
    bot.id = envBotId;
    localStorage.setItem('currentBot', JSON.stringify(bot));
  } catch {
    // localStorage unavailable — fall back to lib defaults
  }
}

bootstrapDevAuth();

const formatLocal = (iso: string) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : `${d.toLocaleString()} (${iso})`;
};
console.log(`[Observation Tools] v${__APP_VERSION__} · built ${formatLocal(__BUILD_TIME__)}`);

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Ensure index.html has a <div id="root"></div>.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
